<div class="page-indicator" role="status">
  @for (page of pages; track page) {
    <div
      class="page-indicator__dot"
      [class.page-indicator__dot--active]="page === currentPage"
    ></div>
  }
</div>
